import React from "react";
import "./MineThunder.css";
import MiningTypeLogo from "../../../assets/MiningTypeLogoText.png";

function MineThunder1() {
  return (
    <div className="mining-type-1-containers">
      <div className="mining-type-1-content">
        <a href="https://minethunder.com" target="_blank" rel="noopener noreferrer">
          <div className="mining-type-1-logo-container">
            <img
              src={MiningTypeLogo}
              alt="MiningTypeLogo"
              className="mining-type-1-logo"
            />
          </div>
        </a>

        <div className="mining-type-1-text-container">
          <h1 className="mining-type-1-main-title">MineThunder.com</h1>
          <h2 className="mining-type-1-second-title">
            Leading the Digital Gold Rush
          </h2>
          <p className="mining-type-1-descriptions">
          MineThunder.com isn't just a digital outpost; it's a stronghold for
            miners, innovators, and trailblazers redefining the landscape of
            cryptocurrency mining. Envision a nexus of servers – a virtual
            terrain where digital currencies are unearthed through cutting-edge
            technology. Our resilient servers transcend mere hardware; they
            embody the architecture of financial evolution. Partnering with
            esteemed ASIC firmware luminaries, MineThunder.com emerges as a
            harbinger of trust, offering an array of proven solutions that
            epitomize triumph in the digital gold rush.
            <br />
            <br />
            • Premium-grade mining servers designed for cryptocurrency mining
            endeavors.
            <br />
            • Diverse server sizes and capacities to accommodate varying needs.
            <br />
            • Seamless compatibility with renowned ASIC firmware providers.
            <br />• An intuitive platform for seamless server acquisition and
            setup.
          </p>
          
        </div>
      </div>
    </div>
  );
}

export default MineThunder1;
